"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.brandAccessApi = brandAccessApi;
exports.brandAccessListApi = brandAccessListApi;
exports.brandAddApi = brandAddApi;
exports.brandAdminListApi = brandAdminListApi;
exports.brandApplyApi = brandApplyApi;
exports.brandBulkHardDeleteApi = brandBulkHardDeleteApi;
exports.brandBulkRestoreApi = brandBulkRestoreApi;
exports.brandBulkSoftDeleteApi = brandBulkSoftDeleteApi;
exports.brandContentListApi = brandContentListApi;
exports.brandDeleteApi = brandDeleteApi;
exports.brandFetchApi = brandFetchApi;
exports.brandListApi = brandListApi;
exports.brandRemoveApi = brandRemoveApi;
exports.brandSoftDeleteApi = brandSoftDeleteApi;
exports.brandSoftDeleteRestoreApi = brandSoftDeleteRestoreApi;
exports.brandSoftDeletedListApi = brandSoftDeletedListApi;
exports.brandUpdateApi = brandUpdateApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * fetch
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function brandFetchApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.fetch), params);
}

/**
 * access
 * @param payload
 * @returns api response
 * @description this function used to get access of data.
 */
function brandAccessApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.access), params);
}

/**
 * list
 * @param payload
 * @returns api response
 * @description this function used to get list of data.
 */
function brandListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.list), params);
}

/**
 * add
 * @param payload
 * @returns api response
 * @description this function used to add data.
 */
function brandAddApi(params) {
  return api.createWithParamBody("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.add), params.param, params.data);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function brandUpdateApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.update), params);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
function brandDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.delete), params);
}

/**
 * remove
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
function brandRemoveApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.remove), params);
}

/**
 * admin list
 * @param payload
 * @returns api response
 * @description this function used to dalete data.
 */
function brandAdminListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.adminList), params);
}

/**
 * brand list
 * @param payload
 * @returns api response
 * @description this function used to get brand list.
 */
function brandContentListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.brandContentList), params);
}

/**
 * access list
 * @param payload
 * @returns api response
 * @description this function used to get access list.
 */
function brandAccessListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.accessList), params);
}

/**
 * apply
 * @param payload
 * @returns api response
 * @description this function used to apply.
 */
function brandApplyApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.apply), params);
}

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft dalete data.
 */
function brandSoftDeleteApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.softDelete), params);
}

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft dalete restore data.
 */
function brandSoftDeleteRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.softDeleteRestore), params);
}

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft daleted list data.
 */
function brandSoftDeletedListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.softDeletedList), params);
}

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft dalete data.
 */
function brandBulkSoftDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.bulkSoftDelete), params);
}

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard dalete data.
 */
function brandBulkHardDeleteApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.bulkHardDelete), params);
}

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore data.
 */
function brandBulkRestoreApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.PlatformService.brand.bulkRestore), params);
}